import { useIntl } from "react-intl";

import { cn } from "../../../../utils";
import { DataForm } from "../../../data-form";
import { Dialog } from "../../../molecules/dialog";
import { useDataTableContext } from "../../context";
import { useDataTableSettingsContext } from "../../context/data-table-settings-context";
import { DataTable } from "../../data-table";
import { useDataTablePreferencesColumns } from "./columns";
import { DataFormPreferencesProvider, useDataFormPreferences } from "./context";
import { DataFormHeader } from "./data-form/components/data-form-header";
import { DataTablePreferencesFormFields } from "./data-form/form-fields";
import { useDataTablePreferenceFormMutation } from "./mutation";
import { dataTablePreferencesBrowseSchema } from "./schema";
import { createDataTablePreferencesApi, viewPreferencesKey } from "./utils";

function DataTablePreferencesBody() {
  const { entity, setEntity, setMode } = useDataFormPreferences();

  const columns = useDataTablePreferencesColumns();

  const mutation = useDataTablePreferenceFormMutation();

  const table = useDataTableContext();

  const { tableId, api } = table;

  return (
    <div
      className={cn("grid h-full grid-cols-1", {
        "grid-cols-2": !!entity,
      })}
    >
      <DataTable
        id={`view-preferences-manage-${tableId}`}
        api={createDataTablePreferencesApi(api)}
        url=""
        deriveRowClassName={(row) =>
          row.id === entity?.id
            ? "bg-primary-100 [&_td]:font-medium [&_td]:text-black"
            : ""
        }
        onRowClick={(row) => {
          setEntity(row);
          setMode("detail");
        }}
        schema={dataTablePreferencesBrowseSchema}
        columns={columns}
        className="overflow-y-auto"
        tableCaption={{
          showNew: false,
          showSearch: true,
          showColumns: false,
          showPreferences: false,
        }}
        queryKey={[...viewPreferencesKey(tableId)]}
        preFilters={[
          {
            field: "tableId",
            operation: "EQ",
            value: tableId,
          },
        ]}
        defaultSorting={[{ id: "createdAt", desc: true }]}
      />

      {!!entity && (
        <DataForm
          className="border-l"
          itemId={entity.id}
          url=""
          api={createDataTablePreferencesApi(api)}
          detailSchema={dataTablePreferencesBrowseSchema}
          formSchema={dataTablePreferencesBrowseSchema}
          mutation={mutation}
          header={<DataFormHeader />}
          fetchData={async () => entity}
        >
          <DataTablePreferencesFormFields />
        </DataForm>
      )}
    </div>
  );
}

export function DataTablePreferencesEvidence() {
  const intl = useIntl();

  const { showManagePreferences, setShowManagePreferences, focusTrigger } =
    useDataTableSettingsContext();

  return (
    <Dialog
      open={showManagePreferences}
      onOpenChange={(open) => {
        setShowManagePreferences(open);
        focusTrigger();
      }}
    >
      <Dialog.Content size="2xl" className="h-[80vh]" showClose={true}>
        <Dialog.Header>
          <Dialog.Title>
            {intl.formatMessage({
              id: "data-table.preferences-settings.manage.title",
              defaultMessage: "Správa přehledů",
            })}
          </Dialog.Title>
        </Dialog.Header>

        <Dialog.Body className="h-full overflow-hidden p-0">
          <DataFormPreferencesProvider key={String(showManagePreferences)}>
            <DataTablePreferencesBody />
          </DataFormPreferencesProvider>
        </Dialog.Body>
      </Dialog.Content>
    </Dialog>
  );
}
